import { inject } from "mobx-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { AuthEvent } from "../../../client/stores";
import type { Store } from "../../../client/stores";
import { Modal } from "../ui";
import "./AuthModal.component.scss";

interface AuthModalProps {
    store?: Store;
}

export const AuthModal = inject("store")(({ store }: AuthModalProps) => {
    if (!store) {
        return null;
    }

    const [mounted, setMounted] = useState(false);
    const [open, setOpen] = useState(false);
    const [moved, setMoved] = useState(false);
    const auth = useRef<HTMLDivElement>(null);

    const handleOpen = useCallback(
        (event: AuthEvent) => {
            const authContainer = document.querySelector("#ihr-auth-container");
            if (auth.current && authContainer && !moved) {
                authContainer.classList.add("auth-container");
                auth.current.replaceWith(authContainer);
                setMoved(true);
            }

            if (mounted && moved) {
                setOpen(event.action === "pending");
            }
        },
        [mounted, moved, setMoved, setOpen],
    );

    const handleClose = useCallback(() => {
        if (mounted) {
            setOpen(false);
        }
    }, [mounted, setOpen]);

    useEffect(() => {
        store.onAuthAction.subscribe(handleOpen);
        if (!mounted) {
            setMounted(true);
        }

        return () => {
            store.onAuthAction.unsubscribe(handleOpen);
        };
    }, [store, mounted, setMounted, handleOpen]);

    return (
        <Modal open={open} callback={handleClose} addClass="auth-modal">
            <div ref={auth} />
        </Modal>
    );
});

export default AuthModal;
